"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Spinner;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AssistiveText = _interopRequireDefault(require("./../AssistiveText"));

var _circleSpinner = _interopRequireDefault(require("./styled/circleSpinner"));

var _arcSpinner = _interopRequireDefault(require("./styled/arcSpinner"));

var _spinnerContainer = _interopRequireDefault(require("./styled/spinnerContainer"));

var _childContainer = _interopRequireDefault(require("./styled/childContainer"));

var _getSizeValue = _interopRequireDefault(require("./helpers/getSizeValue"));
/**
 * Spinners should be shown when retrieving data or performing slow,
 * help to reassure the user that the system is actively retrieving data.
 */


function Spinner(props) {
  var className = props.className,
      style = props.style,
      assistiveText = props.assistiveText,
      isVisible = props.isVisible,
      size = props.size,
      variant = props.variant,
      type = props.type,
      children = props.children;
  var currentSize = (0, _getSizeValue["default"])(size);

  if (isVisible) {
    if (type === 'arc') {
      return _react["default"].createElement(_spinnerContainer["default"], {
        className: className,
        style: style
      }, _react["default"].createElement(_arcSpinner["default"], {
        viewBox: "".concat(0, " ", 0, " ", currentSize, " ").concat(currentSize),
        size: size,
        variant: variant
      }, _react["default"].createElement("circle", {
        className: "path",
        cx: currentSize / 2,
        cy: currentSize / 2,
        r: (currentSize - 3) / 2,
        fill: "none",
        strokeWidth: "3"
      })), _react["default"].createElement(_childContainer["default"], null, children), _react["default"].createElement(_AssistiveText["default"], {
        text: assistiveText
      }));
    }

    return _react["default"].createElement(_circleSpinner["default"], {
      className: className,
      size: size,
      variant: variant,
      style: style
    }, _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement(_childContainer["default"], null, children), _react["default"].createElement(_AssistiveText["default"], {
      text: assistiveText
    }));
  }

  return null;
}

Spinner.propTypes = {
  /** The variant changes the appearance of the spinner.
   * Accepted variants are base, brand, and inverse. This value defaults to base. */
  variant: _propTypes["default"].oneOf(['base', 'brand', 'inverse', 'neutral']),

  /** The size of the spinner. Accepted sizes are xx-small, x-small, small, medium, large and x-large.
   * This value defaults to medium. */
  size: _propTypes["default"].oneOf(['xx-small', 'x-small', 'small', 'medium', 'large', 'x-large']),

  /** Show/Hide the spinner. */
  isVisible: _propTypes["default"].bool,

  /** A description for assistive sreen readers. */
  assistiveText: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** The type of the spinner. Accepted types are circle and arc.
   * This value defaults to circle. */
  type: _propTypes["default"].oneOf(['circle', 'arc']),

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].node
};
Spinner.defaultProps = {
  variant: 'base',
  size: 'medium',
  isVisible: true,
  assistiveText: null,
  className: undefined,
  style: undefined,
  type: 'circle',
  children: null
};